var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "number-count v-align", style: _vm.numberCountStyles },
    [
      _vm.isShowThousand
        ? _c("span", [
            _vm._v(_vm._s(_vm.helper.printThousandDecimal(_vm.displayNumber))),
          ])
        : _c("span", [_vm._v(_vm._s(_vm.displayNumber))]),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }